package de.oevbs.kunde.kundenportal2.model.services.inbox

import de.oevbs.businesspartner.bpcrmservice2.common.model.CRMDocument
import de.oevbs.businesspartner.bpcrmservice2.common.model.LineOfBusiness
import dev.fritz2.core.Lenses
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class Message(
    val id: String,
    val guid: String,
    val subject: String = "",
    val lineOfBusiness: LineOfBusiness = LineOfBusiness.Unbekannt,
    val date: LocalDate = LocalDate(1900, 1, 1),
    val read: Boolean = false,
    val docLinks: List<CRMDocument> = emptyList(),
    val contractNo: String? = null,
    val claimNo: String? = null,
    val detailsLoaded: Boolean = false,
    val isCollapsed: Boolean = true,
    val detailText: String? = null
) { companion object }

@Lenses
@Serializable
data class FromTo(
    val beginYear: Int = 0,
    val endYear: Int = 0
)
{ companion object }
